/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, Dispatch, SetStateAction } from 'react';

import { PermissionConfig } from './types';

const PermissionDefaultState: PermissionConfig = {
  profile: {
    personal: true,
    professional: true,
    academic: true,
  },
  note: true,
  session: true,
  logbook: true,
};

export interface PermissionConfigContextProps {
  permissionsConfig: PermissionConfig;
  setPermissionsConfig?: Dispatch<SetStateAction<PermissionConfig>>;
}

const PermissionConfigDefaultContext: PermissionConfigContextProps = {
  permissionsConfig: PermissionDefaultState,
};

const PermissionConfigContext = createContext<PermissionConfigContextProps>(
  PermissionConfigDefaultContext,
);

const PermissionConfigConsumer = PermissionConfigContext.Consumer;
const PermissionConfigProvider = PermissionConfigContext.Provider;

export {
  PermissionConfigContext,
  PermissionConfigProvider,
  PermissionConfigConsumer,
  PermissionDefaultState,
};
